// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","bottom":"_3iOMmaeLcs1e","promoCode__wrp":"_1U1PGBwoJdHM"};